import { defineMessages } from 'react-intl'
import { DeparturePlace } from './types'

/**
 * List of departure places for routes without a fixed timetable
 */
export const shuttleRoutes: DeparturePlace[] = ['zyrardow']

/**
 * Translation keys for departure places, listed by id
 */
export const directionNames = defineMessages({
    warsaw: {
        id: 'upsells.transport.direction_warsaw',
        defaultMessage: '_',
    },
    zyrardow: {
        id: 'upsells.transport.direction_zyrardow',
        defaultMessage: '_',
    },
    lodz: {
        id: 'upsells.transport.direction_lodz',
        defaultMessage: '_',
    },
    suntago: {
        id: 'upsells.transport.direction_suntago',
        defaultMessage: '_',
    },
})
